import * as Namespaces from './namespaces'

const locales = {
	[Namespaces.REPORTS]: {
		el: {
			'Export': 'Εξαγωγή',
			'Clear': 'Καθαρισμός',
			'Search': 'Αναζήτηση',
			'Reports' : 'Αναφορές',
			'Report' : 'Αναφορά',
			'Projects' : 'Έργα',
			'Workers' : 'Εργαζόμενοι',
			'Worker' : 'Εργαζόμενος',
			'Active' : 'Ενεργά',
			'Inactive' : 'Μη ενεργά',
			'All' : 'Ολα',
			'Description' : 'Περιγαρφή',
			'Start Date' : 'Ημέρα Έναρξης',
			'End Date' : 'Ημέρα Λήξης',
			'Estim. Cost' : 'Προϋπολογισμός',
			'Work Time' : 'Ώρες Εργασίας',
			'Extra Work Time' : 'Υπερωρίες',
			'Extra Work Time(S-S)':'Υπερωρίες(Σ-Κ)',
			'Extra Work Time(M-F)':'Υπερωρίες(Δ-Π)',
			'Per Cost' : 'Ποσοστό Κόστους',
			'Project' : 'Έργο',
			'Work Date' : 'Ημέρα Εργασίας',
			'Work Cost' : 'Κόστος Εργασίας',
			'Extra Work Cost(S-S)':'Υπερ/κο Κόστος(Σ-Κ)',
			'Extra Work Cost(M-F)':'Υπερ/κο Κόστος(Δ-Π)',
			'Extra Work Cost' : 'Υπερωριακό Κόστος',
			'With Contibutions' : 'Με εισφορές',
			'With Contibutions day' : 'Επιβάρυνση Ημερήσιων Ωρών',
			'Payment' : 'Πληρτωτέο',
			'With Contibutions Extra':'Με εισφορές υπερωριακών ωρών(Δ-Π) ',
			'With Out Contibutions' : 'Χωρίς εισφορές',
			'Workers time In Projects':'Ώρες Εργαζομένων σε Έργα'
		},
		en: {
			'WorkDt' : 'Work Date',
		}
	},
}

export default locales